export * from "./DisplayedCurrency";

export const laurianeCalendly = "https://calendly.com/lauriane-m/open-source-economy";
